var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default",class:{
    error: _vm.question.messageStyle === 'error' || _vm.question.messageStyle === 'redinfo',
    'survey-infotext': _vm.question.messageStyle !== 'inline',
    'survey-inlinetext': _vm.question.messageStyle === 'inline'
  }},[_c('div',{staticClass:"panel-heading"},[_c('label',{staticClass:"panel-title"},[(
          _vm.question.messageStyle === 'error' ||
            _vm.question.messageStyle === 'info'
        )?_c('span',{staticClass:"heading-icon fa",class:{
          'fa-ban': _vm.question.messageStyle === 'error',
          'fa-info-circle': _vm.question.messageStyle === 'info'
        }}):_vm._e(),_c('span',{staticClass:"title-text",domProps:{"innerHTML":_vm._s(_vm.titleHtml)}})])]),(_vm.bodyHtml)?_c('div',{staticClass:"panel-body",domProps:{"innerHTML":_vm._s(_vm.bodyHtml)}}):_vm._e(),(_vm.question.isRequired && !_vm.value)?_c('div',{staticClass:"row accept-row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.toggle}},[_c('span',[_vm._v("Continue")])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }